export const ANALISE_REQUEST = "ANALISE_REQUEST";
export const ANALISE_SUCCESS = "ANALISE_SUCCESS";
export const ANALISE_FAIL = "ANALISE_FAIL";
